export default {
    learnMoreButton: 'Saiba mais sobre essa área',

    quickNavigation: {
        title: 'Navegação rápida',
        description: 'Escolha pela navegação rápida ou passe os cards para a esquerda para ver mais opções'
    },

    sections: {
        horoscope: 'Horóscopo e Previsões',
        dailyTools: 'Ferramentas do dia-a-dia',
        birthChart: 'Mapa Astral e Personalidade',
        love: 'Amor e Relacionamento',
        spirituality: 'Espiritualidade e Oráculos',
        learning: 'Curiosidade e Aprendizado'
    },

    tools: {
        dailyHoroscope: {
            title: 'Horóscopo Diário',
            description:
                'Leitura das suas influências do dia com orientações úteis sobre amor, trabalho, dinheiro, saúde, espiritualidade e mais'
        },
        futureHoroscope: {
            title: 'Horóscopo Futuro',
            description:
                'Tendências para os seus próximos dias. Antecipe o que pode acontecer e prepare-se para o que está chegando'
        },
        extraMapsHoroscope: {
            title: 'Horóscopo de Mapas Extras',
            description: 'Interpretação dos trânsitos do dia e também futuros das pessoas cadastradas no seu perfil'
        },
        yearGuide2026: {
            title: 'Guia do Ano 2026',
            description:
                'Uma visão geral e personalizada do seu ano: desafios, oportunidades e momentos-chave para se planejar melhor'
        },
        synastry: {
            title: 'Sinastria',
            description:
                'Leitura da compatibilidade astral entre duas pessoas, revelando afinidades, diferenças e dinâmicas que impactam a convivência'
        },
        loveMap: {
            title: 'Mapa do Amor',
            description:
                'Análise personalizada da sua vida afetiva que mostra padrões emocionais, necessidades nos relacionamentos e formas de se vincular'
        },
        birthChart: {
            title: 'Mapa Astral',
            description:
                'O retrato do céu no momento do seu nascimento. Revela sua personalidade, emoções, potenciais e desafios em todas as áreas da vida'
        },
        summarizedChart: {
            title: 'Mapa Resumido',
            description: 'Os principais pontos do seu mapa astral em uma leitura rápida e fácil de entender'
        },
        lunarNodes: {
            title: 'Nodos Lunares',
            description:
                'Um guia para entender seu propósito de vida, desafios e potencialidades, favorecendo escolhas mais equilibradas'
        },
        lunarCycle: {
            title: 'Ciclo Lunar',
            description:
                'Um guia das fases da Lua que explica influências, desafios e oportunidades em diversas áreas da vida'
        },
        biorhythm: {
            title: 'Biorritmo',
            description:
                'Estudo único mostra como suas energias emocionais, mentais e físicas oscilam ao longo dos dias, indicando quando agir ou desacelerar'
        },
        astrologicalAssistant: {
            title: 'Assistente Astrológico',
            description:
                'Tira dúvidas e oferece orientações personalizadas de acordo com seu mapa astral, de forma rápida e fácil, sempre que você precisar'
        },
        astrologicalDiary: {
            title: 'Diário Astrológico',
            description:
                'Espaço para registrar o céu em determinado momento e revisitar no futuro, observando padrões e acontecimentos do período'
        },
        tarot: {
            title: 'Tarot',
            description: 'Tiragens práticas para refletir sobre escolhas, caminhos possíveis e o sentido dos momentos vividos'
        },
        gypsyDeck: {
            title: 'Baralho Cigano',
            description: 'Leitura das cartas voltada para situações práticas, trazendo clareza sobre questões do cotidiano'
        },
        celebritiesChart: {
            title: 'Mapa dos Famosos',
            description: 'Mapas de pessoas conhecidas para entender como talentos, desafios e traços pessoais se expressam'
        },
        learnAstrology: {
            title: 'Aprenda Astrologia',
            description: 'Conteúdos estruturados para compreender os fundamentos da astrologia de forma clara e gradual'
        },
        learnTarot: {
            title: 'Aprenda Tarot',
            description: 'Material introdutório para entender o Tarot, seus símbolos e formas de interpretação'
        },
        blog: {
            title: 'Artigos',
            description:
                'Conteúdos aprofundados sobre astrologia, bem-estar, comportamento e processos de autoconhecimento'
        },
        guidesArchive: {
            title: 'Guias Astrológicos',
            description: 'Coleção organizada de guias temáticos para consulta e aprofundamento contínuo'
        }
    }
};
